const HEALTH_STYLES: Record<string, string> = {
  healthy: 'bg-green-500',
  degraded: 'bg-yellow-500',
  unhealthy: 'bg-red-500',
};

export function HealthStatusIndicator({ status }: { status: string | null }) {
  if (!status) return <span className="inline-block h-2.5 w-2.5 rounded-full bg-gray-300" title="No health data" />;
  const style = HEALTH_STYLES[status] || 'bg-gray-300';
  return <span className={`inline-block h-2.5 w-2.5 rounded-full ${style}`} title={status} />;
}
